import { FormikProps } from 'formik/dist/types';
import * as Yup from 'yup';
import { CheckBoxItemType } from 'views/components/molecules/checkBoxGroup';
import { ErrorWord, CommonData, EstablishPageType } from '../common';

/*--------------
  投資情報
  --------------*/
//チェックリストからnumber[]をコネコネする
export const finedIds = (items: CheckBoxItemType[], baseList: CommonData[]) => {
  const labelList = items?.filter((item) => item.checked)?.map((data) => data.label);
  return baseList?.filter((ex: CommonData) => labelList?.includes(ex.value))?.map((data) => data.id);
};
//登録情報更新時の初期データ作成用のベースメソッド
const createAccountInfoList = (numList: number[], baseList: CommonData[], checkList: CheckBoxItemType[]) => {
  const strList: string[] = baseList?.filter((item) => numList?.includes(item.id))?.map((data) => data.value);
  const infoList: CheckBoxItemType[] = checkList?.map((item) => {
    return { label: item.label, checked: strList?.includes(item.label) };
  });
  return infoList;
};

//証券投資のご経験のあれこれ
//リスト名
export enum Experiences {
  GOVERNMENT_CORPORATE_BONDS = '国債・普通社債',
  STOCK_INVESTMENT_TRUSTS = '株式型投資信託',
  PUBLIC_INVESTMENT_TRUSTS = '公社債型投資信託',
  EXCHANGE_TRADED_FUND = '株式・ETF（上場投資信託）',
  STOCK_MARGIN_TRADING = '株式信用取引',
  LEVERAGED_INVESTMENT_PRODUCTS = 'レバレッジのある投資商品',
  FOREIGN_STOCKS = '外国株式',
  FOREIGN_BONDS = '外国債券',
  REAL_ESTATE_INVESTMENT_TRUSTS = '不動産投資信託',
  REAL_ESTATE_DOWNSIZING_PRODUCTS = '不動産小口化商品',
  BENEFICIARY_CERTIFICATE_ISSUING_TRUST = '受益証券発行信託',
  NO_EXPERIENCE = '投資経験なし',
}

//{ id: number; value: string }[]のデータ作る
const ExperiencesList: CommonData[] = (Object.keys(Experiences) as (keyof typeof Experiences)[]).map((key, index) => {
  return { id: key === 'NO_EXPERIENCE' ? 99 : index + 1, value: Experiences[key] };
});
//チェックボックス用のデータ作る
export const ExperiencesCheckList: CheckBoxItemType[] = ExperiencesList.map((data) => {
  return { label: data.value, checked: false };
});
//number[]を取得
export const finedExperiencesIds = (items: CheckBoxItemType[]) => {
  return finedIds(items, ExperiencesList);
};
//登録情報更新時の初期データ作成用
export const createExperiencesInfoList = (list: number[]) => {
  return createAccountInfoList(list, ExperiencesList, ExperiencesCheckList);
};

//ご投資の方針のご経験のあれこれ
//リスト名
export enum Policy {
  PRINCIPAL = '元本重視',
  INTEREST_DICIDEND = '利子・配当重視',
  BALANCE = '利子・配当と値上がり益のバランスを重視',
  PROFIT = '値上がり益を重視',
  PROFIT_PROACTIVE = '値上がり益を積極追求',
}

//{ id: number; value: string }[]のデータ作る
const PolicyList: CommonData[] = (Object.keys(Policy) as (keyof typeof Policy)[]).map((key, index) => {
  return { id: index + 1, value: Policy[key] };
});
//string[]のデータ作る
export const PolicyStrs = PolicyList.map((data) => data.value);
//{ id: number; value: string }[]からリスト名でid取得する
export const finedPolicyId = (str: string) => {
  return PolicyList.find((data) => data.value === str)?.id;
};
//{ id: number; value: string }[]からidでリスト名取得する
export const finedPolicyStr = (id: number) => {
  return PolicyList.find((data) => data.id === id)?.value;
};

//弊社ご利用にあたってのご投資目的のあれこれ
//リスト名
export enum Purposes {
  FUTURE = '将来のための資産形成',
  SOON = '近々に使途が確定している資金の運用',
  SURPLUS_FUNDS = '余裕資金の運用',
}

//{ id: number; value: string }[]のデータ作る
const PurposesList: CommonData[] = (Object.keys(Purposes) as (keyof typeof Purposes)[]).map((key, index) => {
  return { id: index + 1, value: Purposes[key] };
});
//チェックボックス用のデータ作る
export const PurposesCheckList: CheckBoxItemType[] = PurposesList.map((data) => {
  return { label: data.value, checked: false };
});
//number[]を取得する
export const finedPurposesIds = (items: CheckBoxItemType[]) => {
  return finedIds(items, PurposesList);
};
//登録情報更新時の初期データ作成用
export const createPurposesInfoList = (list: number[]) => {
  return createAccountInfoList(list, PurposesList, PurposesCheckList);
};

//年収のあれこれ
//リスト名
export enum AnnualIncome {
  LESS_FIVE_MILLION = '500万円未満',
  FIVE_MILLION_TO_LESS_TEN_MILLION = '500万円〜1,000万円未満',
  TEN_MILLION_TO_LESS_THITY_MILLION = '1,000万円〜3,000万円未満',
  THITY_MILLION_TO_LESS_FIFTY_MILLION = '3,000万円〜5,000万円未満',
  FIFTY_MILLION_MORE = '5,000万円以上',
}

//{ id: number; value: string }[]のデータ作る
const AnnualIncomeList: CommonData[] = (Object.keys(AnnualIncome) as (keyof typeof AnnualIncome)[]).map(
  (key, index) => {
    return { id: index + 1, value: AnnualIncome[key] };
  },
);
//string[]のデータ作る
export const AnnualIncomeStrs = AnnualIncomeList.map((data) => data.value);
//{ id: number; value: string }[]からリスト名でid取得する
export const finedAnnualIncomeId = (str: string) => {
  return AnnualIncomeList.find((data) => data.value === str)?.id;
};
//{ id: number; value: string }[]からidでリスト名取得する
export const finedAnnualIncomeStr = (id: number) => {
  return AnnualIncomeList.find((data) => data.id === id)?.value;
};

//収入形態のあれこれ
//リスト名
export enum IncomeForm {
  SALARY = '給与',
  BUSINESS_INCOME = '事業収入',
  REAL_ESTATE_BALANCE = '不動産収入',
  INTEREST_DICIDEND = '利子・配当',
  PENSION = '年金',
  OTHER = 'その他',
}

//{ id: number; value: string }[]のデータ作る
const IncomeFormList: CommonData[] = (Object.keys(IncomeForm) as (keyof typeof IncomeForm)[]).map((key, index) => {
  return { id: index + 1, value: IncomeForm[key] };
});
//チェックボックス用のデータ作る
export const IncomeFormCheckList: CheckBoxItemType[] = IncomeFormList.map((data) => {
  return { label: data.value, checked: false };
});
//number[]を取得する
export const finedIncomeFormIds = (items: CheckBoxItemType[]) => {
  return finedIds(items, IncomeFormList);
};
//登録情報更新時の初期データ作成用
export const createIncomeFormInfoList = (list: number[]) => {
  return createAccountInfoList(list, IncomeFormList, IncomeFormCheckList);
};

//金融資産のあれこれ
//リスト名
export enum FinancialAssets {
  LESS_TWO_MILLION = '200万円未満',
  TWO_MILLION_TO_LESS_FIVE_MILLION = '200万円〜500万円未満',
  FIVE_MILLION_TO_LESS_TEN_MILLION = '500万円〜1,000万円未満',
  TEN_MILLION_TO_LESS_TWENTY_MILLION = '1,000万円〜2,000万円未満',
  TWENTY_MILLION_TO_LESS_THITY_MILLION = '2,000万円〜3,000万円未満',
  THITY_MILLION_TO_LESS_FIFTY_MILLION = '3,000万円〜5,000万円未満',
  FIFTY_MILLION_TO_LESS_ONE_HUNDRED_MILLION = '5,000万円〜1億円未満',
  ONE_HUNDRED_MILLION_MORE = '1億円以上',
}

//{ id: number; value: string }[]のデータ作る
const FinancialAssetsList: CommonData[] = (Object.keys(FinancialAssets) as (keyof typeof FinancialAssets)[]).map(
  (key, index) => {
    return { id: index + 1, value: FinancialAssets[key] };
  },
);
//string[]のデータ作る
export const FinancialAssetsStrs = FinancialAssetsList.map((data) => data.value);
//{ id: number; value: string }[]からリスト名でid取得する
export const finedFinancialAssetsId = (str: string) => {
  return FinancialAssetsList.find((data) => data.value === str)?.id;
};
//{ id: number; value: string }[]からidでリスト名取得する
export const finedFinancialAssetsStr = (id: number) => {
  return FinancialAssetsList.find((data) => data.id === id)?.value;
};

//入力値の型
export type InvestmentInfoType = {
  // 証券投資のご経験
  investmentExperiences: CheckBoxItemType[]; //number[]にしてリクエスト;
  // ご投資の方針
  investmentPolicy: string | null; //Intに変換してリクエスト必要
  // 弊社ご利用にあたってのご投資目的
  investmentPurposes: CheckBoxItemType[]; //number[]にしてリクエスト;
  // 年収
  annualIncome: string | null; //Intに変換してリクエスト必要
  // 収入形態
  incomeForm: CheckBoxItemType[]; //number[]にしてリクエスト;
  // 金融資産
  financialAssets: string | null; //Intに変換してリクエスト必要
};
//Formik用の型
export type InvestmentInfoFormikType = FormikProps<InvestmentInfoType>;

//Formikに渡す初期値
export const investmentInfoInitialValues = (param: InvestmentInfoType) => {
  return {
    ...param,
    investmentExperiences: param.investmentExperiences || ExperiencesCheckList,
    investmentPolicy: param.investmentPolicy ?? null,
    investmentPurposes: param.investmentPurposes || PurposesCheckList,
    annualIncome: param.annualIncome ?? null,
    incomeForm: param.incomeForm || IncomeFormCheckList,
    financialAssets: param.financialAssets ?? null,
  };
};

//バリデーション
const investmentArraySchema = Yup.object().shape({
  label: Yup.string(),
  checked: Yup.boolean(),
});
const yapArrayCheck = Yup.array()
  .of(investmentArraySchema)
  .test('ArrayCheck', ErrorWord.SELECT_ONE_OR_MORE, (list) => list?.some((item) => item.checked));
export const investmentInfoValidation = Yup.object().shape({
  investmentExperiences: yapArrayCheck,
  investmentPolicy: Yup.string().required(ErrorWord.SELECT),
  investmentPurposes: yapArrayCheck,
  annualIncome: Yup.string().required(ErrorWord.SELECT),
  incomeForm: yapArrayCheck,
  financialAssets: Yup.string().required(ErrorWord.SELECT),
});

//Formikのサブミットメソッド
export const investmentInfoOnSubmit = <T>(param: T, add: (data: T) => void, cb?: () => void) => {
  return (values: InvestmentInfoType) => {
    add({
      ...param,
      investmentExperiences: values.investmentExperiences,
      investmentPolicy: values.investmentPolicy,
      investmentPurposes: values.investmentPurposes,
      annualIncome: values.annualIncome,
      incomeForm: values.incomeForm,
      financialAssets: values.financialAssets,
    });
    cb && cb();
  };
};
